import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import '../../../../../Utils/accountLevel.css'

type Props = {
  show: boolean
  handleClose: () => void
  accountName?: string
  parentAccountId?: number
  parentAccountName?: string
}

const AccountHierarchyModal: FC<Props> = ({
  show,
  handleClose,
  accountName,
  parentAccountId,
  parentAccountName,
}) => {
  const navigate = useNavigate()

  const initials =
    (parentAccountName ?? '').charAt(0).toUpperCase() +
    (parentAccountName ?? '').charAt(1).toUpperCase()

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Account Hierarchy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='fs-6 mb-4'>
          <span className='fw-bold text-gray-800'>{accountName}</span> is a sub-account of:
        </div>
        <div className='account-hierarchy-parent-card rounded d-flex align-items-center p-4'>
          <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
            <div className='symbol-label bg-light-success'>
              <span className='fs-5 fw-bold text-gray-800'>{initials}</span>
            </div>
          </div>
          <div className='d-flex flex-column'>
            <span className='account-hierarchy-parent-label fs-7 fw-bold'>Parent Account</span>
            <span className='account-hierarchy-parent-name fs-6'>{parentAccountName}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-sm btn-light' onClick={handleClose}>
          Close
        </button>
        <button
          type='button'
          className='btn btn-sm btn-primary'
          onClick={() => navigate('/customers/' + parentAccountId)}
        >
          View Parent Account
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export {AccountHierarchyModal}
